import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Row, Col, Form, FloatingLabel, Button, Card, CardHeader, CardBody, Modal } from "react-bootstrap";
import { FaUser, FaIdCard, FaIdCardAlt } from "react-icons/fa";
import { DivideTitleComponent } from "../../components";
import { useValidation } from "../../context/ValidationContext";
import TinyMCEEditor from "./draft/TextEditorWithTable";
import PageLayout from "../../layouts/PageLayout";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import Persondetails from "./draft/PerosonDetails";
import FamilyDetails from "./draft/FamilyDetails";
import FamilyStory from "./draft/FamilyStory";
import FamilyChildrens from "./draft/FamilyChildrens";
import LoanDetails from "./draft/LoanDetails";
import BusinessDetails from "./draft/BusinessDetails";
import axiosInstance from "../../context/axiosInstance";
import { FaFileInvoice } from "react-icons/fa";
import { BsFillBookFill } from "react-icons/bs";
import axios from "axios";
import Swal from 'sweetalert2'
import AddNewBrickKiln from "./BrickKiln/AddNewBrickkiln";
import StoreBrickkiln from "./BrickKiln/StoreBrickkiln";
export default function DraftForm() {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [error, setError] = useState({});
  const [isFocused, setIsFocused] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [searchValue, setSearchValue] = useState(""); // State for the input value
  const [showModal, setShowModal] = useState(false);
  const [formState, setFormState] = useState({
    identifier_id: null,
    beneficiary_name: null,
    gender_id: null,
    slavery_years: null,
    mob: null,
    cnic: null,
    dob: null,
    marital_status_id: null,
    slavery_reason_id: null,
    occupation_id: null,
    cnic_expire_date: null,
    faith_id: null,
    baptised: null,
    city_id: null,
    assessment_date: null,
    present_address: null,
    permanent_address: null,
    avatar: { file: null, preview: null },
    cnic_f_img: { file: null, preview: null },
    cnic_b_img: { file: null, preview: null },
    union_council: null,
    flagged: null,
    is_member_of_church: 0,
    ///Family details
    is_parent_dependent: false,
    father_name: null,
    father_cnic: null,
    father_dob: null,
    father_slavry_years: null,
    father_is_dead: null,
    mother_name: null,
    mother_cnic: null,
    mother_dob: null,
    mother_slavry_years: null,
    mother_is_dead: null,
    spouse_name: null,
    spouse_cnic: null,
    spouse_dob: null,
    spouse_slavry_year: null,
    spouse_is_dead: null,
    relationship_id: null,
    kin_list: [],
    ///Family story 
    family_story: null,
    extra_comments: null,
    prayer_request: null,
    ///Childrens
    no_child: false,
    children: [],
    ///Loan
    brick_kiln_id: null,
    loan_type_id: null,
    est_loan_amount: null,
    medical_amount: null,
    food_ration: null,
    meal_amount: null,
    khatta_amount: null,
    utility_amount: null,
    rent_amount: null,
    other: null,
    affidavit_amount: null,
    total_pkr: 0,
    unpaid_loan_first_file: { file: null, preview: null },
    unpaid_loan_last_file: { file: null, preview: null },
    khatta_unpaid_first_file: { file: null, preview: null },
    khatta_unpaid_last_file: { file: null, preview: null },

    //Business
    business_type_id: null,
    estimated_cost: null,
    another_details: null,

    //Acknowledgement
    identifier: null,
    mobilizer: null,
    mobilizer_id: null,

    //Brickkiln Assesment
    working_years_on_brick_kiln: null,
    loan_year: null,
    first_loan_amount: null,
    number_of_dependents: null,
    number_of_work_dependents: null,
    worker_list: [],
    live_on_brick_kiln: null,
    live_by_choice: null,
    reason: null,
    is_allow_to_meet_relatives: null,
    living_address: null,
    distance_to_home: null,
    working_hours: null,

    want_to_leave_work: null,
    why: null,
    plans_after_leaving_work: null,
    willing_to_learn_new_skills: null,
    new_skill_or_job: null,
    willing_to_pay_in_installments: null,
    willing_to_educate_children: null,
  });
  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);
  const handleStoreModal = (brickkiln) => {
    // Update data to include the new brick kiln
    setData((prevData) => ({
      ...prevData,
      brickkilns: [...prevData.brickkilns, brickkiln],
    }));

    // Set the newly added brick kiln as the selected option
    setFormState((prevState) => ({
      ...prevState,
      brick_kiln_id: brickkiln.id,
    }));

    setShowModal(false);
  };

  const validateTab1 = () => {
    const requiredFields = [
      "identifier_id",
      "beneficiary_name",
      "gender_id",
      "slavery_years",
      "mob",
      "cnic",
      "dob",
      "marital_status_id",
      "slavery_reason_id",
      "occupation_id",
      "cnic_expire_date",
      "faith_id",
      "city_id",
      "assessment_date",
      "present_address",
      "permanent_address",
      "union_council",

    ];

    // if (error?.cnic) {
    //   return false; // Stop further processing if validation fails
    // }
    // for (let field of requiredFields) {
    //   if (!formState[field]) {

    //     return false; // Stop further processing if validation fails
    //   }
    // }
    return true;
  };

  // Validation for Tab 2
  const validateTab4 = () => {
    const requiredFields = [
      "brick_kiln_id",
      "loan_type_id",
      "est_loan_amount",
    ];
    // for (let field of requiredFields) {
    //   if (!formState[field]) {
    //     return false; // Stop further processing if validation fails
    //   }
    // }
    return true;
  };

  const validateTab5 = () => {
    const requiredFields = [
      "business_type_id",
      "estimated_cost",
    ];
    // for (let field of requiredFields) {
    //   if (!formState[field]) {
    //     return false; // Stop further processing if validation fails
    //   }
    // }
    return true;
  };
  // error messages
  const errorMessages = () => {
    // you can add alert or console.log or any thing you want

    Swal.fire({
      title: 'Error!',
      text: 'Please fill in the required fields',
      icon: 'error',
      confirmButtonText: 'Ok'
    })
  };

  const [currentTab, setCurrentTab] = useState(0);

  const tabChanged = ({
    prevIndex,
    nextIndex,
  }) => {

    console.log("nextIndex", nextIndex);
  };
  const [filteredCities, setFilteredCities] = useState([]);

  const { formatCnic, validateCnic, validateImageDimensions } = useValidation();


  const handleSearch = (value) => {
    setSearchValue(value); // Update the input value
    if (value.trim() === "") {
      setFilteredCities([]); // Clear suggestions if input is empty
    } else {
      const filtered = data?.cities?.filter((city) =>
        city.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCities(filtered);
    }
  };

  const handleFileChange = async (e, fieldName, width, height) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Validate and resize the image
        const resizedImage = await validateImageDimensions(file, width, height);
        const previewUrl = URL.createObjectURL(resizedImage);

        setFormState((prevState) => ({
          ...prevState,
          [fieldName]: {
            file: resizedImage,
            preview: previewUrl,
          },
        }));
        setError(""); // Clear any previous errors
      } catch (err) {
        setError("Invalid image file or dimensions.");
      }
    }
  };
  const checkCnic = async (value) => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + "/check-cnic", {
        cnic: value,
      });
      console.log(response.data);
      if (response?.data?.success === false) {
        setError((prevError) => ({
          ...prevError,
          cnic: response?.data?.message?.cnic,
        }));
      }
    } catch (error) {
      console.error("Error Posting Data", error);
    }
  };

  const AuthToken = localStorage.getItem("AuthUser");



  const createFormData = (data) => {
    const apiformData = new FormData();

    Object.keys(data).forEach((key) => {
      const value = data[key];

      if (Array.isArray(value)) {
        // If the value is an array, append it as a JSON string
        apiformData.append(key, JSON.stringify(value));
      } else if (typeof value === "object" && value !== null) {
        // Handle object fields
        if (value.file && value.file instanceof File) {
          // If the object has a 'file' key, append the file
          apiformData.append(key, value.file);
        } else {
          // Handle nested objects
          Object.keys(value).forEach((nestedKey) => {
            const nestedValue = value[nestedKey];
            if (nestedValue) {
              apiformData.append(`${key}[${nestedKey}]`, nestedValue);
            }
          });
        }
      } else {
        // Append scalar values (strings, numbers, booleans)
        apiformData.append(key, value);
      }
    });

    return apiformData;
  };



  const handleComplete = () => {
    const apiformData = createFormData(formState);
    console.log(apiformData);
    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
    axios.post(process.env.REACT_APP_API_URL + '/add-draft-family', apiformData)
      .then((res) => {
        console.log(res, 'res');
        if (res.data.success) {
          navigate('/darft-list');
          Swal.fire({
            title: 'Success!',
            text: 'Draft saved successfully.',
            icon: 'success',
            confirmButtonText: 'Ok'

          });
        } else {
          Swal.fire({
            title: 'Error!',
            text: 'Please fill in the required fields.',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          // Extract errors into an array
          const errors = error.response.data.errors;
          const errorList = Object.values(errors)
            .flat() // Flatten nested arrays
            .map((err) => `<li>${err}</li>`) // Convert each error into an HTML list item
            .join(''); // Join all list items

          // Display errors in a bulleted list
          Swal.fire({
            title: 'Please fix the following errors!',
            html: `<ul>${errorList}</ul>`,
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass: {
              popup: 'text-left' // Align text to the left for better readability
            }
          });
        } else {
          // Generic error message
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong. Please try again.',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      });

    // Handle form completion logic here
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/common/family-initial-data"
        );
        setData(response.data.data);
        console.log(response, 'called');
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  const handleIdentifier = (e) => {
    const selectedId = parseInt(e.target.value, 10);
    const selectedIdentifier = data.identifiers.find((iden) => iden.id === selectedId);

    setFormState((prevState) => ({
      ...prevState,
      identifier_id: selectedId,
      identifier: selectedIdentifier || null,
    }));

    console.log(selectedIdentifier, 'iden')
  };

  const handleMobilizer = (e) => {
    const selectedId = parseInt(e.target.value, 10);
    const selectedIdentifier = data.identifiers.find((iden) => iden.id === selectedId);

    setFormState((prevState) => ({
      ...prevState,
      mobilizer_id: selectedId,
      mobilizer: selectedIdentifier || null,
    }));

    console.log(selectedIdentifier, 'iden')
  };

  const handleChange = (e) => {


    const { name, value, type, files } = e.target;
    console.log(name, 'name')
    // Handle file input
    if (type === "file") {
      const file = files[0];
      const previewUrl = file ? URL.createObjectURL(file) : null;

      setFormState((prevState) => ({
        ...prevState,
        [name]: {
          file,
          preview: previewUrl,
        },
      }));
    } else if (value === "add_new") {
      handleModalShow();
    } else {
      // Handle regular input fields
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    // Handle CNIC field
    if (name === "cnic") {
      const formattedCnic = formatCnic(value); // Format CNIC input
      if (value.length >= 14) {

        console.log(value)
        checkCnic(formattedCnic);
      }


      setFormState((prevState) => ({
        ...prevState,
        cnic: formattedCnic, // Update formatted CNIC in the form state
      }));

      // Validate CNIC
      setError((prevError) => ({
        ...prevError,
        cnic: validateCnic(formattedCnic) ? "" : "", // Set error if CNIC is invalid
      }));
    }

    if (name === "city_id") {
      handleSearch(value);
    }


  };


  const addKin = () => {
    setFormState({
      ...formState,
      kin_list: [
        ...formState.kin_list,
        {
          id: formState.kin_list.length + 1,
          relationship_id: "",
          name: "",
          cnic: "",
          dob: "",
          slavry_year: "",
        },
      ],
    });
  };

  const removeKin = (index) => {
    const updatedkin_list = formState.kin_list.filter((_, i) => i !== index);
    setFormState({
      ...formState,
      kin_list: updatedkin_list,
    });
  };

  const handleKinChange = (index, e) => {
    const { name, value } = e.target;

    // Create a copy of the kin_list
    const updatedkin_list = [...formState.kin_list];

    let formattedValue = value;

    // Check if the field is 'cnic' and apply validation
    if (name === 'cnic') {
      // Format and ensure CNIC is 15 characters long
      formattedValue = formatCnic(value);
      if (formattedValue.length > 15) {
        formattedValue = formattedValue.slice(0, 15); // Truncate to 15 characters
      }
    }

    // Update the specific kin's field
    updatedkin_list[index] = {
      ...updatedkin_list[index],
      [name]: formattedValue,
    };

    // Update the state
    setFormState({
      ...formState,
      kin_list: updatedkin_list,
    });
  };


  const handleChangeStory = ({ name, value }) => {
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const addKid = () => {
    setFormState({
      ...formState,
      children: [
        ...formState.children,
        {
          id: formState.children.length + 1,
          school_going: "",
          name: "",
          gender_id: "",
          dob: "",
          slavery_years: "",
          cnic: "",
          vocational_center: "",
        },
      ],
    });
  };

  const removeKid = (index) => {
    const updatedchilds = formState.children.filter((_, i) => i !== index);
    setFormState({
      ...formState,
      children: updatedchilds,
    });
  };

  const handleKidChange = (index, e) => {
    const { name, value } = e.target;

    // Copy the existing child array
    const updatedchilds = [...formState.children];

    let formattedValue = value;

    // Apply formatting and validation for CNIC
    if (name === 'cnic') {
      formattedValue = formatCnic(value);
      if (formattedValue.length > 15) {
        formattedValue = formattedValue.slice(0, 15); // Truncate to 15 characters
      }
    }

    // Update the specific child's field
    updatedchilds[index] = {
      ...updatedchilds[index],
      [name]: formattedValue,
    };

    // Update the state
    setFormState({
      ...formState,
      children: updatedchilds,
    });
  };


  const handleChangeLoan = (e) => {
    const { name, value } = e.target;

    setFormState((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };

      // Recalculate total_pkr
      const total = [
        "loan_amount",
        "medical_amount",
        "food_ration",
        "meal_amount",
        "khatta_amount",
        "utility_amount",
        "rent_amount",
        "other",
        "affidavit_amount",
      ].reduce((acc, key) => acc + (parseFloat(updatedState[key]) || 0), 0);

      return { ...updatedState, total_pkr: total };
    });
  };

  const updateCnicField = (field, value) => {
    const formattedCnic = formatCnic(value); // Format CNIC input
    setFormState((prevState) => ({
      ...prevState,
      [field]: formattedCnic, // Update formatted CNIC in the form state
    }));
  };
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                <i className="material-icons">family_restroom</i> Add New Family
                Record
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="/" className="mc-breadcrumb-link">
                    Home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">New Family Record</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <FormWizard
              shape="circle"
              color="#0858f7"
              onComplete={handleComplete}
              onTabChange={tabChanged}
            >

              <FormWizard.TabContent title="Beneficiary Details" icon="ti-user" >
                <>
                  <Row className="mb-3">
                    <Row style={{ position: "relative" }}>
                      <Col md={4}>
                        <div className="mc-card" style={{ position: "relative" }}>
                          <Form.Group>
                            <Form.Label
                              style={{
                                width: "100%",
                                textAlign: "center",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {!formState.avatar.preview ? (
                                <>
                                  {"Add Beneficiary Pic"}
                                  <i
                                    style={{
                                      color: "#1976D2",
                                      cursor: "pointer",
                                      fontSize: "4rem",
                                    }}
                                    className="material-icons"
                                  >
                                    <FaUser />
                                  </i>
                                </>
                              ) : (
                                <img
                                  src={formState.avatar.preview}
                                  alt="Beneficiary Pic"
                                  style={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: "10px",
                                    objectFit: "cover",
                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                    border: "2px solid #1976D2",
                                    padding: "5px",
                                  }}
                                />
                              )}
                              <Form.Control
                                type="file"
                                hidden
                                name="avatar"
                                placeholder="Add Beneficiary Pic"
                                onChange={(e) =>
                                  handleFileChange(e, "avatar", 500, 500)
                                }
                              />

                            </Form.Label>
                            {formState.avatar?.file ? "" :
                              <span className="c_error">
                                Please add Profile Picture
                              </span>
                            }
                          </Form.Group>
                        </div>
                      </Col>

                      <Col md={8}>
                        <Row>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Select Partner"
                              className="mb-3"
                            >
                              <Form.Select
                                onChange={(e) => handleIdentifier(e)}
                                name="identifier_id"
                                value={formState.identifier_id}
                                required
                              >
                                <option value={""}>Select...</option>
                                {data?.identifiers?.map((identifier) => (
                                  <option key={identifier.id} value={identifier.id}>
                                    {identifier.name} ({identifier.org})
                                  </option>
                                ))}
                              </Form.Select>
                              {formState.identifier_id ? "" :
                                <span className="c_error">
                                  Please Select Identifier
                                </span>
                              }

                            </FloatingLabel>

                          </Form.Group>
                          <Form.Group

                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Assesment Date"
                              className="mb-3"
                            >
                              <Form.Control

                                type="date"
                                onChange={handleChange}
                                name="assessment_date"
                                placeholder=""
                                value={formState.assessment_date}
                              />
                              {formState.assessment_date ? "" :
                                <span className="c_error">
                                  Please enter assessment date
                                </span>
                              }
                            </FloatingLabel>

                          </Form.Group>
                          <Form.Group

                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Beneficiary Name"
                              className="mb-3"
                            >
                              <Form.Control
                                required
                                type="text"
                                onChange={handleChange}
                                name="beneficiary_name"
                                placeholder=""
                                value={formState.beneficiary_name}
                              />
                              {formState.beneficiary_name ? "" :
                                <span className="c_error">
                                  Please Enter Beneficiary Name
                                </span>
                              }
                            </FloatingLabel>

                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Select Gender"
                              className="mb-3"
                            >
                              <Form.Select

                                type="text"
                                onChange={handleChange}
                                name="gender_id"
                                placeholder=""
                                value={formState.gender_id}
                              >
                                <option value={""}>Select...</option>
                                {data?.gender?.map((gender) => (
                                  <option key={gender.id} value={gender.id}>{gender.name}</option>
                                ))}
                              </Form.Select>
                              {formState.gender_id ? "" :
                                <span className="c_error">
                                  Please Select Gender
                                </span>
                              }
                            </FloatingLabel>
                          </Form.Group>
                          <Col md={6}>
                            <div className="mc-card" style={{ position: "relative" }}>
                              <Form.Group>
                                <Form.Label
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {!formState.cnic_f_img.preview ? (
                                    <>
                                      {"Add Beneficiary CNIC Front"}
                                      <i
                                        style={{
                                          color: "#1976D2",
                                          cursor: "pointer",
                                          fontSize: "4rem",
                                        }}
                                        className="material-icons"
                                      >
                                        <FaIdCard />
                                      </i>
                                    </>
                                  ) : (
                                    <img
                                      src={formState.cnic_f_img.preview}
                                      alt="Beneficiary CNIC Front"
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "10px",
                                        objectFit: "cover",
                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                        border: "2px solid #1976D2",
                                        padding: "5px",
                                      }}
                                    />
                                  )}
                                  <Form.Control
                                    type="file"
                                    hidden
                                    name="cnic_f_img"
                                    placeholder="Add Beneficiary CNIC Front"
                                    onChange={(e) =>
                                      handleFileChange(e, "cnic_f_img", 500, 250)
                                    }
                                  />
                                </Form.Label>
                                {formState.cnic_f_img.file ? "" :
                                  <span className="c_error">
                                    Please Add Beneficiary CNIC Front
                                  </span>
                                }
                              </Form.Group>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mc-card" style={{ position: "relative" }}>
                              <Form.Group>
                                <Form.Label
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {!formState.cnic_b_img.preview ? (
                                    <>
                                      {"Add Beneficiary CNIC Back"}
                                      <i
                                        style={{
                                          color: "#1976D2",
                                          cursor: "pointer",
                                          fontSize: "4rem",
                                        }}
                                        className="material-icons"
                                      >
                                        <FaIdCardAlt />
                                      </i>
                                    </>
                                  ) : (
                                    <img
                                      src={formState.cnic_b_img.preview}
                                      alt="Beneficiary CNIC Back"
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "10px",
                                        objectFit: "cover",
                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                        border: "2px solid #1976D2",
                                        padding: "5px",
                                      }}
                                    />
                                  )}
                                  <Form.Control
                                    type="file"
                                    hidden
                                    name="cnic_b_img"
                                    placeholder="Add Beneficiary CNIC Back"
                                    onChange={(e) =>
                                      handleFileChange(e, "cnic_b_img", 500, 250)
                                    }
                                  />

                                </Form.Label>
                                {formState.cnic_b_img.file ? "" :
                                  <span className="c_error ">
                                    Please Add Beneficiary CNIC Back
                                  </span>
                                }
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Form.Group

                      as={Col}
                      md="4"
                      className="mb-3"
                    >
                      <FloatingLabel label="Enter CNIC">
                        <Form.Control
                          type="text"
                          placeholder="Enter CNIC"

                          name="cnic"
                          value={formState.cnic}
                          onChange={handleChange}
                          maxLength={15} // Prevent user from typing more than 15 characters
                          minLength={15}
                        />
                        {formState.cnic ? "" :
                          <span className="c_error">
                            Please Enter CNIC
                          </span>
                        }
                      </FloatingLabel>
                      {error?.cnic && (
                        <span
                          className="c_error"
                        >
                          {`${String(error?.cnic || "").toUpperCase()}*`}

                        </span>
                      )}
                    </Form.Group>

                    <Form.Group

                      as={Col}
                      md="4"
                      controlId="validationCustom01"
                    >
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="CNIC Expiry Date"
                        className="mb-3"
                      >
                        <Form.Control

                          type="date"
                          onChange={handleChange}
                          name="cnic_expire_date"
                          placeholder=""
                          value={formState.cnic_expire_date}
                        />
                        {formState.cnic_expire_date ? "" :
                          <span className="c_error">
                            Please Enter CNIC Expiry Date
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group

                      as={Col}
                      md="4"
                      controlId="validationCustom01"
                    >
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Cell Number"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="mob"
                          placeholder=""
                          value={formState.mob}
                        />
                        {formState.mob ? "" :
                          <span className="c_error">
                            Please Enter Cell Number
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>


                    <Form.Group as={Col} md="4" className="mb-3">
                      <FloatingLabel label="Date of Birth">
                        <Form.Control
                          type="date"
                          placeholder="Date of Birth"

                          name="dob"
                          value={formState.dob}
                          onChange={handleChange}
                        />
                        {formState.dob ? "" :
                          <span className="c_error">
                            Please Select Date of Birth
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom02">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Marital Status"
                        className="mb-3"
                      >
                        <Form.Select

                          name="marital_status_id"
                          value={formState.marital_status_id}
                          onChange={handleChange}
                        >
                          <option value="">Select...</option>
                          {data?.maritalStatuses?.map((martital) => {
                            return <option key={martital.id} value={martital.id}>{martital.name}</option>;
                          })}
                        </Form.Select>
                        {formState.marital_status_id ? "" :
                          <span className="c_error">
                            Please Select Marital Status
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Occupation"
                        className="mb-3"
                      >
                        <Form.Select

                          name="occupation_id"
                          value={formState.occupation_id}
                          onChange={handleChange}
                        >
                          <option value="">Select Occupation</option>
                          {data?.occupations?.map((occupation) => (
                            <option key={occupation.id} value={occupation.id}>{occupation.name}</option>
                          ))}
                        </Form.Select>
                        {formState.occupation_id ? "" :
                          <span className="c_error">
                            Please Select Occupation
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>


                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Slavery Reason"
                        className="mb-3"
                      >
                        <Form.Select

                          name="slavery_reason_id"
                          value={formState.slavery_reason_id}
                          onChange={handleChange}
                        >
                          <option value="">Slavery Reason</option>
                          {data?.slaveryReasons?.map((slaveryReason) => (
                            <option key={slaveryReason.id} value={slaveryReason.id}>{slaveryReason.name}</option>
                          ))}
                        </Form.Select>
                        {formState.slavery_reason_id ? "" :
                          <span className="c_error">
                            Please Select Slavery Reason
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Slavery Years"
                        className="mb-3"
                      >
                        <Form.Control

                          type="number"
                          onChange={handleChange}
                          name="slavery_years"
                          placeholder=""
                          value={formState.slavery_years}
                        />
                        {formState.slavery_years ? "" :
                          <span className="c_error">
                            Required
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Religion"
                        className="mb-3"
                      >
                        <Form.Select

                          name="faith_id"
                          value={formState.faith_id}
                          onChange={handleChange}
                        >
                          <option value="">Select Religion</option>
                          {data?.religions?.map((religion) => (
                            <option key={religion.id} value={religion.id}>{religion.name}</option>
                          ))}
                        </Form.Select>
                        {formState.faith_id ? "" :
                          <span className="c_error">
                            Required
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>

                    {formState.faith_id == 2 ? <>
                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Baptized"
                          className="mb-3"
                        >
                          <Form.Select

                            name="baptised"
                            value={formState.baptised}
                            onChange={handleChange}
                          >
                            <option value="">Choose</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Flagged"
                          className="mb-3"
                        >
                          <Form.Select

                            name="flagged"
                            value={formState.flagged}
                            onChange={handleChange}
                          >
                            <option value="">Choose</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Member of a Church"
                          className="mb-3"
                        >
                          <Form.Select

                            name="is_member_of_church"
                            value={formState.is_member_of_church}
                            onChange={handleChange}
                          >
                            <option value="">Choose</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Form.Group>

                      {
                        formState.is_member_of_church == 1 ? <>
                          <DivideTitleComponent title="Church Details" className="mb-4 mt-3" />
                          <Form.Group as={Col} md="4" controlId="validationCustom01">
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Church Name"
                              className="mb-3"
                            >
                              <Form.Control

                                type="text"
                                onChange={handleChange}
                                name="church_name"
                                placeholder=""
                                value={formState.church_name}
                              />

                            </FloatingLabel>
                          </Form.Group>
                          <Form.Group as={Col} md="4" controlId="validationCustom01">
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Pastor Name"
                              className="mb-3"
                            >
                              <Form.Control

                                type="text"
                                onChange={handleChange}
                                name="pastor_name"
                                placeholder=""
                                value={formState.pastor_name}
                              />

                            </FloatingLabel>
                          </Form.Group>

                          <Form.Group as={Col} md="4" controlId="validationCustom01">
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Pastor Cell Number"
                              className="mb-3"
                            >
                              <Form.Control

                                type="text"
                                onChange={handleChange}
                                name="pastor_cell_number"
                                placeholder=""
                                value={formState.pastor_cell_number}
                              />

                            </FloatingLabel>
                          </Form.Group>
                          <Form.Group as={Col} md="4" controlId="validationCustom01">
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="Visited By Pastor"
                              className="mb-3"
                            >
                              <Form.Select

                                name="is_visited_by_pastor"
                                value={formState.is_visited_by_pastor}
                                onChange={handleChange}
                              >
                                <option value="">Choose</option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                              </Form.Select>
                            </FloatingLabel>
                          </Form.Group>
                          <Form.Group as={Col} md="4" controlId="validationCustom01">
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="How frequent?"
                              className="mb-3"
                            >
                              <Form.Select

                                name="frequent"
                                value={formState.frequent}
                                onChange={handleChange}
                              >
                                <option value="">Choose</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Monthly">Monthly</option>
                              </Form.Select>
                            </FloatingLabel>
                          </Form.Group>

                          <Form.Group as={Col} md="4" controlId="validationCustom01">
                            <FloatingLabel
                              controlId="floatingTextarea"
                              label="When was your last church visit?"
                              className="mb-3"
                            >
                              <Form.Control

                                type="text"
                                onChange={handleChange}
                                name="last_time_church"
                                placeholder=""
                                value={formState.last_time_church}
                              />

                            </FloatingLabel>
                          </Form.Group>
                        </> : ""
                      }

                    </>





                      : ""
                    }
                  </Row>

                  <DivideTitleComponent title="Address Details" className="mb-4 mt-3" />

                  <Row>
                    <Form.Group as={Col} md="6" className="mb-3">
                      <FloatingLabel label="Union Council">
                        <Form.Control
                          type="text"
                          placeholder=""

                          name="union_council"
                          value={formState.union_council}
                          onChange={handleChange}
                        />
                        {formState.union_council ? "" :
                          <span className="c_error">
                            Please Enter Union Council
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="6" className="mb-3" style={{ position: "relative" }}>
                      <FloatingLabel label="City">
                        <Form.Control
                          type="text"
                          placeholder="Enter City"
                          value={searchValue} // Use the search value to display what the user types
                          onChange={(e) => {
                            handleSearch(e.target.value); // Update search
                            setFormState((prevState) => ({
                              ...prevState,
                              city_id: "", // Clear city_id while typing
                            }));
                          }}
                          onFocus={() => setIsFocused(true)}
                          onBlur={() => setTimeout(() => setIsFocused(false), 150)} // Delay hiding dropdown
                          name="city_id"
                        />
                        {!formState.city_id && (
                          <span className="c_error">Please Enter City</span>
                        )}
                      </FloatingLabel>

                      {isFocused && (
                        <ul
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: "0",
                            right: "0",
                            background: "#fff",
                            border: "1px solid #ddd",
                            zIndex: 1000,
                            maxHeight: "150px",
                            overflowY: "auto",
                            listStyleType: "none",
                            padding: "0",
                            margin: "0",
                          }}
                        >
                          {filteredCities.length > 0 ? (
                            filteredCities.map((city) => (
                              <li
                                key={city.id}
                                onClick={() => {
                                  setSearchValue(city.name); // Set the city name as input value
                                  setFormState((prevState) => ({
                                    ...prevState,
                                    city_id: city.id, // Store city ID in the state
                                  }));
                                  setIsFocused(false); // Close dropdown after selection
                                }}
                                style={{
                                  padding: "10px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                }}
                              >
                                {city.name}
                              </li>
                            ))
                          ) : (
                            <li
                              style={{
                                padding: "10px",
                                cursor: "default",
                                textAlign: "center",
                                color: "#888",
                              }}
                            >
                              No city with this name
                            </li>
                          )}
                        </ul>
                      )}
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Present Address"
                        className="mb-3"
                      >
                        <Form.Control

                          type="textarea"
                          placeholder="Enter Present Address"
                          onChange={handleChange}
                          name="present_address"
                          value={formState.present_address}
                        />
                        {formState.present_address ? "" :
                          <span className="c_error">
                            Please Enter Present Address
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Permanent Address"
                        className="mb-3"
                      >
                        <Form.Control

                          type="textarea"
                          placeholder="Enter Permanent Address"
                          onChange={handleChange}
                          name="permanent_address"
                          value={formState.permanent_address}
                        />
                        {formState.permanent_address ? "" :
                          <span className="c_error">
                            Please Enter Permanent Address
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                </>
                {/* <Persondetails
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Person Details", childData)
                  }
                /> */}

              </FormWizard.TabContent>

              <FormWizard.TabContent title="Beneficiary Family" icon="ti-home" isValid={validateTab1()} validationError={errorMessages}>

                <>
                  <Row className="mb-3">
                    <Col md={7}>
                      {" "}
                      <DivideTitleComponent
                        title="Parents Information"
                        className="mb-4 mt-3"
                      />
                    </Col>
                    <Col md={5}>
                      <Form.Check
                        type={"checkbox"}
                        id={`default-1`}
                        name="is_parent_dependent"
                        checked={formState.is_parent_dependent} // Bind to state
                        onChange={(e) =>
                          setFormState({ ...formState, is_parent_dependent: e.target.checked })
                        } // Inline change handler
                        label={"Parents are Dependent on Beneficiary ? "}
                      />
                    </Col>
                  </Row>
                  {formState.is_parent_dependent ? <>
                    <Row>

                      <Col md={12}>
                        <DivideTitleComponent
                          title="Father Information"
                          className="mb-4 mt-3"
                        />
                      </Col>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Father Name"
                          className="mb-3"
                        >
                          <Form.Control

                            type="text"
                            onChange={handleChange}
                            name="father_name"
                            placeholder=""
                            value={formState.father_name}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Father CNIC"
                          className="mb-3"
                        >
                          <Form.Control

                            type="text"
                            maxLength={15}
                            onChange={(event) => updateCnicField('father_cnic', event.target.value)}
                            name="father_cnic"
                            placeholder=""
                            value={formState.father_cnic}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Father D-O-B"
                          className="mb-3"
                        >
                          <Form.Control

                            type="date"
                            onChange={handleChange}
                            name="father_dob"
                            placeholder=""
                            value={formState.father_dob}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Slavery Years *"
                          className="mb-3"
                        >
                          <Form.Control

                            type="number"
                            onChange={handleChange}
                            name="father_slavry_years"
                            placeholder=""
                            value={formState.father_slavry_years}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Is Dead ?"
                          className="mb-3"
                        >
                          <Form.Select

                            onChange={handleChange}
                            name="father_is_dead"
                            placeholder=""
                            value={formState.father_is_dead}
                          >
                            <option value={0}>No</option>
                            <option value={1}>Yes</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Form.Group>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <DivideTitleComponent
                          title="Mother Information"
                          className="mb-4 mt-3"
                        />
                      </Col>
                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Mother Name"
                          className="mb-3"
                        >
                          <Form.Control

                            type="text"
                            onChange={handleChange}
                            name="mother_name"
                            placeholder=""
                            value={formState.mother_name}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Mother CNIC"
                          className="mb-3"
                        >
                          <Form.Control

                            type="text"
                            maxLength={15}
                            onChange={(event) => updateCnicField('mother_cnic', event.target.value)}

                            name="mother_cnic"
                            placeholder=""
                            value={formState.mother_cnic}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Mother D-O-B"
                          className="mb-3"
                        >
                          <Form.Control

                            type="date"
                            onChange={handleChange}
                            name="mother_dob"
                            placeholder=""
                            value={formState.mother_dob}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Slavery Years *"
                          className="mb-3"
                        >
                          <Form.Control

                            type="number"
                            onChange={handleChange}
                            name="mother_slavry_years"
                            placeholder=""
                            value={formState.mother_slavry_years}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Is Dead ?"
                          className="mb-3"
                        >
                          <Form.Select

                            onChange={handleChange}
                            name="mother_is_dead"
                            placeholder=""
                            value={formState.mother_is_dead}
                          >
                            <option value={0}>No</option>
                            <option value={1}>Yes</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Form.Group>
                    </Row>
                  </>
                    : ""}
                  <Row>
                    <Col md={12}>
                      <DivideTitleComponent
                        title="Spouse Information"
                        className="mb-4 mt-3"
                      />
                    </Col>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Spouse Name"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="spouse_name"
                          placeholder=""
                          value={formState.spouse_name}
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Spouse CNIC"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          maxLength={15}
                          onChange={(event) => updateCnicField('spouse_cnic', event.target.value)}
                          name="spouse_cnic"
                          placeholder=""
                          value={formState.spouse_cnic}
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Spouse D-O-B"
                        className="mb-3"
                      >
                        <Form.Control

                          type="date"
                          onChange={handleChange}
                          name="spouse_dob"
                          placeholder=""
                          value={formState.spouse_dob}
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Slavery Years *"
                        className="mb-3"
                      >
                        <Form.Control

                          type="number"
                          onChange={handleChange}
                          name="spouse_slavry_year"
                          placeholder=""
                          value={formState.spouse_slavry_year}
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Is Dead ?"
                        className="mb-3"
                      >
                        <Form.Select

                          onChange={handleChange}
                          name="spouse_is_dead"
                          placeholder=""
                          value={formState.spouse_is_dead}
                        >
                          <option>No</option>
                          <option>Yes</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <DivideTitleComponent title="Kin Information" className="mb-4 mt-3" />
                    </Col>
                  </Row>

                  {formState.kin_list?.map((kin, kinIndex) => (
                    <Row>
                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingSelect"
                          label="Relation"
                          className="mb-3"
                        >
                          <Form.Select

                            onChange={(e) => handleKinChange(kinIndex, e)}
                            name="relationship_id"
                            value={kin.relationship_id}
                          >
                            <option value="">Select Relation</option>
                            {data?.relations.map((relation, index) => (
                              <option key={index} value={relation.id}>
                                {relation.name}
                              </option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>
                      </Form.Group>


                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Name"
                          className="mb-3"
                        >
                          <Form.Control

                            type="text"
                            onChange={(e) => handleKinChange(kinIndex, e)}
                            name="name"
                            placeholder=""
                            value={kin.name}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="CNIC"
                          className="mb-3"
                        >
                          <Form.Control

                            type="text"
                            onChange={(e) => handleKinChange(kinIndex, e)}
                            name="cnic"
                            maxLength={15}
                            placeholder=""
                            value={kin.cnic}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="D-O-B"
                          className="mb-3"
                        >
                          <Form.Control

                            type="date"
                            onChange={(e) => handleKinChange(kinIndex, e)}
                            name="dob"
                            placeholder=""
                            value={kin.dob}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <FloatingLabel
                          controlId="floatingTextarea"
                          label="Slavery Years *"
                          className="mb-3"
                        >
                          <Form.Control

                            type="text"
                            onChange={(e) => handleKinChange(kinIndex, e)}
                            name="slavry_year"
                            placeholder=""
                            value={kin.slavry_year}
                          />
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <h4 className="mt-3">
                          Kin #{kinIndex + 1}
                          <i
                            title="Remove Kin"
                            className="material-icons float-end text-danger pe-auto"
                            style={{ cursor: "pointer" }}
                            onClick={() => removeKin(kinIndex)}
                          >
                            delete
                          </i>
                        </h4>
                      </Form.Group>
                    </Row>
                  ))}

                  <Row>
                    <Col md="6" className="mx-auto mb-3">
                      <Button
                        className="mt-3 bnt-sm btn-block w-100"
                        variant="success"
                        onClick={() => addKin()}
                      >
                        + Add Kin
                      </Button>
                    </Col>
                  </Row>
                </>
                {/* <FamilyDetails
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Family Details", childData)
                  }
                /> */}
              </FormWizard.TabContent>

              <FormWizard.TabContent title="Family Story" icon="ti-ink-pen"  >
                <>
                  <Row>
                    <Form.Group as={Col} md="12" controlId={`story-1`}>
                      <Form.Label>Family Story</Form.Label>
                      <Form.Control

                        as="textarea"
                        onChange={handleChange}
                        name="family_story"
                        placeholder="Enter Family Story Here..."
                        rows={20}
                        value={formState.family_story}
                      />
                    </Form.Group>


                    <Form.Group as={Col} md="12" controlId={`story-1`}>
                      <Form.Label>Extra Comments</Form.Label>
                      <Form.Control

                        as="textarea"
                        onChange={handleChange}
                        name="extra_comments"
                        placeholder="Enter More Details About Family..."
                        rows={20}
                        value={formState.extra_comments}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="12" controlId={`story-1`}>
                      <Form.Label>Prayer Request</Form.Label>
                      <Form.Control

                        as="textarea"
                        onChange={handleChange}
                        name="prayer_request"
                        placeholder="Enter Family Prayer Request Here..."
                        rows={20}
                        value={formState.prayer_request}
                      />
                    </Form.Group>
                  </Row>
                </>

                {/* <FamilyStory
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Family Story", childData)
                  }
                /> */}
              </FormWizard.TabContent>

              <FormWizard.TabContent
                title="Beneficiary Childrens"
                icon="ti-face-smile"
              >
                <>
                  <Row className="mb-3">

                    <Col md={5}>
                      <Form.Check
                        type={"checkbox"}
                        id={`default-1`}
                        name="is_parent_dependent"
                        checked={formState.no_child} // Bind to state
                        onChange={(e) =>
                          setFormState({ ...formState, no_child: e.target.checked })
                        } // Inline change handler
                        label={"Beneficiary Has No Child ? "}
                      />
                    </Col>

                  </Row>
                  {
                    !formState.no_child ?
                      <>
                        <Row>
                          <Col md={12}>
                            <DivideTitleComponent
                              title="Childrens Information"
                              className="mb-4 mt-3"
                            />
                          </Col>
                        </Row>

                        {formState.children.map((kid, kidIndex) => (
                          <Row>
                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingTextarea"
                                label="Name"
                                className="mb-3"
                              >
                                <Form.Control

                                  type="text"
                                  onChange={(e) => handleKidChange(kidIndex, e)}
                                  name="name"
                                  placeholder=""
                                  value={kid.name}
                                />
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingTextarea"
                                label="Gender"
                                className="mb-3"
                              >
                                <Form.Select

                                  type="text"
                                  onChange={(e) => handleKidChange(kidIndex, e)}
                                  name="gender_id"
                                  placeholder=""
                                  value={kid.gender_id}
                                >
                                  <option>Select</option>
                                  <option value={1}>Boy</option>
                                  <option value={2}>Girl</option>
                                </Form.Select>
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingTextarea"
                                label="D-O-B"
                                className="mb-3"
                              >
                                <Form.Control

                                  type="date"
                                  onChange={(e) => handleKidChange(kidIndex, e)}
                                  name="dob"
                                  placeholder=""
                                  value={kid.dob}
                                />
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingTextarea"
                                label="Slavery Years *"
                                className="mb-3"
                              >
                                <Form.Control

                                  type="text"
                                  onChange={(e) => handleKidChange(kidIndex, e)}
                                  name="slavery_years"
                                  placeholder=""
                                  value={kid.slavery_years}
                                />
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingTextarea"
                                label="CNIC"
                                className="mb-3"
                              >
                                <Form.Control

                                  type="text"
                                  onChange={(e) => handleKidChange(kidIndex, e)}
                                  name="cnic"
                                  placeholder=""
                                  maxLength={15}
                                  value={kid.cnic}
                                />
                              </FloatingLabel>
                            </Form.Group>

                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingTextarea"
                                label="School Going"
                                className="mb-3"
                              >
                                <Form.Select

                                  type="text"
                                  onChange={(e) => handleKidChange(kidIndex, e)}
                                  name="school_going"
                                  placeholder=""
                                  value={kid.school_going}
                                >
                                  <option>Select</option>
                                  <option value={1}> Yes</option>
                                  <option value={0}>No</option>
                                </Form.Select>
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingTextarea"
                                label="Vocational Refer"
                                className="mb-3"
                              >
                                <Form.Select

                                  type="text"
                                  onChange={(e) => handleKidChange(kidIndex, e)}
                                  name="vocational_center"
                                  placeholder=""
                                  value={kid.vocational_center}
                                >
                                  <option>Select</option>
                                  <option value={1}>Yes</option>
                                  <option value={0}>No</option>
                                </Form.Select>
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} md="2" controlId="validationCustom01">
                              <h4 className="mt-3">
                                Kid #{kidIndex + 1}
                                <i
                                  title="Remove Kid"
                                  className="material-icons float-end text-danger pe-auto"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => removeKid(kidIndex)}
                                >
                                  delete
                                </i>
                              </h4>
                            </Form.Group>
                          </Row>
                        ))}

                        <Row>
                          <Col md="6" className="mx-auto mb-3">
                            <Button
                              className="mt-3 bnt-sm btn-block w-100"
                              variant="success"
                              onClick={() => addKid()}
                            >
                              + Add Kid
                            </Button>
                          </Col>
                        </Row>
                      </> : ""
                  }
                </>
                {/* <FamilyChildrens
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Family Children", childData)
                  }
                /> */}
              </FormWizard.TabContent>

              <FormWizard.TabContent title="Loan Details" icon="ti-money">
                {/* <LoanDetails
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Loan Details", childData)
                  }
                /> */}
                <>
                  <Row>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="validationCustom01"
                    >
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Select BrickKiln"
                        className="mb-3"
                      >
                        {/* Brick Kiln List */}
                        <Form.Select
                          type="text"
                          onChange={handleChange}
                          name="brick_kiln_id"
                          value={formState.brick_kiln_id}
                        >

                          <option value={""}>Select...</option>
                          <option value="add_new">Add New Brick Kiln</option>
                          {data?.brickkilns?.map((brickkiln) => (
                            <option key={brickkiln.id} value={brickkiln.id}>
                              {brickkiln.brickkiln_name}
                            </option>
                          ))}

                        </Form.Select>
                        {formState.brick_kiln_id ? "" :
                          <span className="c_error">
                            Please Select BrickKiln
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Loan Type"
                        className="mb-3"
                      >
                        <Form.Select

                          onChange={handleChangeLoan}
                          name="loan_type_id"
                          placeholder=""
                          value={formState.loan_type_id}
                        >
                          <option value={""}>Select</option>
                          {
                            data?.loanTypes?.map((type) => {
                              return (
                                <option key={type.id} value={type.id}>{type.name}</option>
                              )
                            })
                          }

                        </Form.Select>
                        {formState.loan_type_id ? "" :
                          <span className="c_error">
                            Please Select Loan Type
                          </span>
                        }
                      </FloatingLabel>
                    </Form.Group>


                    <Col md={6}>
                      <FloatingLabel label="Debt Ledger" className="mb-3">
                        <Form.Control
                          type="number"
                          name="est_loan_amount"
                          value={formState.est_loan_amount}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                        {formState.est_loan_amount ? "" :
                          <span className="c_error">
                            Please Enter Debt Ledger
                          </span>
                        }
                      </FloatingLabel>
                      <div className="mc-card" style={{ position: "relative" }}>
                        <Form.Group>
                          <Form.Label
                            style={{
                              width: "100%",
                              textAlign: "center",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {!formState.unpaid_loan_first_file.preview ? (
                              <>
                                {"Unpaid Loan File First Page"}
                                <i
                                  style={{
                                    color: "#1976D2",
                                    cursor: "pointer",
                                    fontSize: "4rem",
                                  }}
                                  className="material-icons"
                                >
                                  <FaFileInvoice />
                                </i>
                              </>
                            ) : (
                              <img
                                src={formState.unpaid_loan_first_file.preview}
                                alt="unpaid_loan_first_file"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  borderRadius: "10px",
                                  objectFit: "cover",
                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                  border: "2px solid #1976D2",
                                  padding: "5px",
                                }}
                              />
                            )}
                            <Form.Control
                              type="file"
                              hidden
                              name="unpaid_loan_first_file"
                              placeholder="unpaid_loan_first_file"
                              onChange={(e) =>
                                handleFileChange(e, "unpaid_loan_first_file", 500, 600)
                              }
                            />
                            {formState.unpaid_loan_first_file ? "" :
                              <span className="c_error">
                                Please Add Unpaid Loan File First Page
                              </span>
                            }
                          </Form.Label>
                        </Form.Group>
                      </div>
                      <div className="mc-card" style={{ position: "relative" }}>
                        <Form.Group>
                          <Form.Label
                            style={{
                              width: "100%",
                              textAlign: "center",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {!formState.unpaid_loan_last_file.preview ? (
                              <>
                                {"Unpaid Loan File Last Page"}
                                <i
                                  style={{
                                    color: "#1976D2",
                                    cursor: "pointer",
                                    fontSize: "4rem",
                                  }}
                                  className="material-icons"
                                >
                                  <FaFileInvoice />
                                </i>
                              </>
                            ) : (
                              <img
                                src={formState.unpaid_loan_last_file.preview}
                                alt="unpaid_loan_last_file"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  borderRadius: "10px",
                                  objectFit: "cover",
                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                  border: "2px solid #1976D2",
                                  padding: "5px",
                                }}
                              />
                            )}
                            <Form.Control
                              type="file"
                              hidden
                              name="unpaid_loan_last_file"
                              placeholder="unpaid_loan_last_file"
                              onChange={(e) =>
                                handleFileChange(e, "unpaid_loan_last_file", 500, 600)
                              }
                            />
                            {formState.unpaid_loan_last_file ? "" :
                              <span className="c_error">
                                Please Add Unpaid Loan File Last Page
                              </span>
                            }
                          </Form.Label>
                        </Form.Group>
                      </div>
                    </Col>


                    <Col md={6}>
                      <FloatingLabel label="Khatta Amount" className="mb-3">
                        <Form.Control
                          type="number"
                          name="khatta_amount"
                          value={formState.khatta_amount}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                      <div className="mc-card" style={{ position: "relative" }}>
                        <Form.Group>
                          <Form.Label
                            style={{
                              width: "100%",
                              textAlign: "center",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {!formState.khatta_unpaid_first_file.preview ? (
                              <>
                                {"Khatta Unpaid File First Page"}
                                <i
                                  style={{
                                    color: "#1976D2",
                                    cursor: "pointer",
                                    fontSize: "4rem",
                                  }}
                                  className="material-icons"
                                >
                                  <BsFillBookFill />
                                </i>
                              </>
                            ) : (
                              <img
                                src={formState.khatta_unpaid_first_file.preview}
                                alt="khatta_unpaid_first_file"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  borderRadius: "10px",
                                  objectFit: "cover",
                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                  border: "2px solid #1976D2",
                                  padding: "5px",
                                }}
                              />
                            )}
                            <Form.Control
                              type="file"
                              hidden
                              name="khatta_unpaid_first_file"
                              placeholder="khatta_unpaid_first_file"
                              onChange={(e) =>
                                handleFileChange(e, "khatta_unpaid_first_file", 500, 600)
                              }
                            />
                          </Form.Label>
                        </Form.Group>
                      </div>
                      <div className="mc-card" style={{ position: "relative" }}>
                        <Form.Group>
                          <Form.Label
                            style={{
                              width: "100%",
                              textAlign: "center",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {!formState.khatta_unpaid_last_file.preview ? (
                              <>
                                {"Khatta Unpaid File Last Page"}
                                <i
                                  style={{
                                    color: "#1976D2",
                                    cursor: "pointer",
                                    fontSize: "4rem",
                                  }}
                                  className="material-icons"
                                >
                                  <BsFillBookFill />
                                </i>
                              </>
                            ) : (
                              <img
                                src={formState.khatta_unpaid_last_file.preview}
                                alt="khatta_unpaid_last_file"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  borderRadius: "10px",
                                  objectFit: "cover",
                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                  border: "2px solid #1976D2",
                                  padding: "5px",
                                }}
                              />
                            )}
                            <Form.Control
                              type="file"
                              hidden
                              name="khatta_unpaid_last_file"
                              placeholder="khatta_unpaid_last_file"
                              onChange={(e) =>
                                handleFileChange(e, "khatta_unpaid_last_file", 500, 600)
                              }
                            />
                          </Form.Label>
                        </Form.Group>
                      </div>
                    </Col>
                    <Form.Group as={Col} md="6" controlId="medicalAmount">
                      <FloatingLabel label="Medical Amount" className="mb-3">
                        <Form.Control
                          type="number"
                          name="medical_amount"
                          value={formState.medical_amount}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="foodRation">
                      <FloatingLabel label="Food Ration" className="mb-3">
                        <Form.Control
                          type="number"
                          name="food_ration"
                          value={formState.food_ration}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="mealAmount">
                      <FloatingLabel label="Meal Amount" className="mb-3">
                        <Form.Control
                          type="number"
                          name="meal_amount"
                          value={formState.meal_amount}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>


                    <Form.Group as={Col} md="6" controlId="utilityAmount">
                      <FloatingLabel label="Utility Amount" className="mb-3">
                        <Form.Control
                          type="number"
                          name="utility_amount"
                          value={formState.utility_amount}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="rentAmount">
                      <FloatingLabel label="Rent Amount" className="mb-3">
                        <Form.Control
                          type="number"
                          name="rent_amount"
                          value={formState.rent_amount}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="other">
                      <FloatingLabel label="Other" className="mb-3">
                        <Form.Control
                          type="number"
                          name="other"
                          value={formState.other}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="affidavitAmount">
                      <FloatingLabel label="Affidavit Amount" className="mb-3">
                        <Form.Control
                          type="number"
                          name="affidavit_amount"
                          value={formState.affidavit_amount}
                          onChange={handleChangeLoan}
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="totalPkr">
                      <FloatingLabel label="Total PKR" className="mb-3">
                        <Form.Control
                          type="number"
                          value={formState.total_pkr}
                          readOnly
                          placeholder=""
                        />
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                </>
              </FormWizard.TabContent>

              <FormWizard.TabContent title="Family Assesment" icon="ti-wand" isValid={validateTab4()} validationError={errorMessages}>

                <>
                  <Row>
                    <DivideTitleComponent title="Feasibility Assessment (Sustaiability)" className="mb-4 mt-3" />
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Do you want to leave this work?"
                        className="mb-3"
                      >
                        <Form.Select

                          onChange={handleChange}
                          name="want_to_leave_work"
                          placeholder=""
                          value={formState.want_to_leave_work}
                        >
                          <option value={""}>Choose</option>
                          <option value={"1"}>Yes</option>
                          <option value={"0"}>No</option>

                        </Form.Select>

                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Why?"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="why"
                          placeholder="why..."
                          value={formState.why}
                        />

                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="What's next after this?"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="plans_after_leaving_work"
                          placeholder="What will you do after leaving this work?"
                          value={formState.plans_after_leaving_work}
                        />

                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Ready to learn new skills ?"
                        className="mb-3"
                      >
                        <Form.Select

                          onChange={handleChange}
                          name="willing_to_learn_new_skills"
                          placeholder=""
                          value={formState.willing_to_learn_new_skills}
                        >
                          <option value={""}>Choose</option>
                          <option value={"1"}>Yes</option>
                          <option value={"0"}>No</option>

                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Any new skills or jobs in mind?"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="new_skill_or_job"
                          placeholder=""
                          value={formState.new_skill_or_job}
                        />

                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="If helped to start, Pay in installments?"
                        className="mb-3"
                      >
                        <Form.Select

                          onChange={handleChange}
                          name="willing_to_pay_in_installments"
                          placeholder=""
                          value={formState.willing_to_pay_in_installments}
                        >
                          <option value={""}>Choose</option>
                          <option value={"1"}>Yes</option>
                          <option value={"0"}>No</option>

                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                    <DivideTitleComponent title="Vulnerability/Feasibility Assessment (Slavery & Loan)" className="mb-4 mt-3" />
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Working Years On Brick Kiln"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="working_years_on_brick_kiln"
                          placeholder=""
                          value={formState.working_years_on_brick_kiln}
                        />

                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="What was the year you took loan?"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="loan_year"
                          placeholder=""
                          value={formState.loan_year}
                        />

                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="What was the first loan amount?"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="first_loan_amount"
                          placeholder=""
                          value={formState.first_loan_amount}
                        />

                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="How many dependents you have?"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="number_of_dependents"
                          placeholder=""
                          value={formState.number_of_dependents}
                        />

                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="How many dependant working"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="number_of_work_dependents"
                          placeholder=""
                          value={formState.number_of_work_dependents}
                        />

                      </FloatingLabel>
                    </Form.Group>
                    
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Relations of working dependants"
                        className="mb-3"
                      >
                        <Form.Select

                          
                          onChange={handleChange}
                          name="worker_list"
                          placeholder=""
                          value={formState.worker_list}
                          >

                            <option value={""}>choose</option>
                            <option value={"Mother"}>Mother</option>
                            <option value={"Father"}>Father</option>
                            <option value={"Spouse"}>Spouse</option>
                            <option value={"Childrens"}>Childrens</option>
                          </Form.Select>
                        

                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Normal working hours?"
                        className="mb-3"
                      >
                        <Form.Control

                          type="text"
                          onChange={handleChange}
                          name="working_hours"
                          placeholder=""
                          value={formState.working_hours}
                        />

                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Allowed to visit relatives?"
                        className="mb-3"
                      >
                        <Form.Select

                          onChange={handleChange}
                          name="is_allow_to_meet_relatives"
                          placeholder=""
                          value={formState.is_allow_to_meet_relatives}
                        >
                          <option value={""}>Choose</option>
                          <option value={"1"}>Yes</option>
                          <option value={"0"}>No</option>

                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <FloatingLabel
                        controlId="floatingTextarea"
                        label="Living On Brick Kiln"
                        className="mb-3"
                      >
                        <Form.Select

                          onChange={handleChange}
                          name="live_on_brick_kiln"
                          placeholder=""
                          value={formState.live_on_brick_kiln}
                        >
                          <option value={""}>Choose</option>
                          <option value={"1"}>Yes</option>
                          <option value={"0"}>No</option>

                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                    {
                      formState.live_on_brick_kiln == 1 ? <>
                        <Form.Group as={Col} md="4" controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingTextarea"
                            label="Are you living here  by choice ?"
                            className="mb-3"
                          >
                            <Form.Select

                              onChange={handleChange}
                              name="live_by_choice"
                              placeholder=""
                              value={formState.live_by_choice}
                            >
                              <option value={""}>Choose</option>
                              <option value={"1"}>Yes</option>
                              <option value={"0"}>No</option>

                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingTextarea"
                            label="Why live on the brick kiln?"
                            className="mb-3"
                          >
                            <Form.Control

                              onChange={handleChange}
                              name="reason"
                              placeholder=""
                              value={formState.reason}
                            />

                          </FloatingLabel>
                        </Form.Group>

                      </>
                        : formState.live_on_brick_kiln == 0 ? <>
                        <Form.Group as={Col} md="4" controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingTextarea"
                            label="Living Address"
                            className="mb-3"
                          >
                            <Form.Control

                              onChange={handleChange}
                              name="living_address"
                              placeholder=""
                              value={formState.living_address}
                            />

                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingTextarea"
                            label="How far is your home?"
                            className="mb-3"
                          >
                            <Form.Control

                              onChange={handleChange}
                              name="distance_to_home"
                              placeholder=""
                              value={formState.distance_to_home}
                            />

                          </FloatingLabel>
                        </Form.Group>
                        </> : ""}


                  </Row>
                </>
              </FormWizard.TabContent>

              <FormWizard.TabContent title="UnderTaking" icon="ti-pencil-alt" isValid={validateTab5()} validationError={errorMessages} >
                <Row>
                  <Card>
                    <CardHeader>
                      {/* <img className="img-setting" height={50} src="/images/fsf.png" alt="logo" /> */}

                      <strong>Undertaking:</strong> (this undertaking will be given by identifying Partner)</CardHeader>
                    <CardBody>

                      <p className="text-justify mb-40"> I <strong className="text-underline">{formState.identifier?.name}</strong> with CNIC <strong className="text-underline">{formState.identifier?.cnic}</strong> herby verify that the above mentioned information is accurate to the best of my knowledge and I am verifying that this person is in dire need of support.</p>
                      <Row>
                        <Col md={6}>
                          <strong>Name of Partner:</strong> {formState.identifier?.name}
                        </Col>
                        <Col md={6}>
                          <strong>   Organization:</strong> {formState.identifier?.org}
                        </Col>
                        <Col md={6} className="mt-3">
                          <strong>        Cell No: </strong>{formState.identifier?.phone}
                        </Col>
                        <Col md={6} className="mt-3">
                          <strong>      Signature:</strong> <img src={formState.identifier?.signature} height={50} />
                        </Col>
                        <DivideTitleComponent title="Social Mobilizer" className="mb-4 mt-3" />
                        <Col md={6}>
                          <strong>Name of Partner:</strong>

                          <select
                            onChange={(e) => handleMobilizer(e)}
                            required
                            value={formState.mobilizer_id}
                            className="text-underline"
                          >
                            <option value={""}>Select...</option>
                            {data?.identifiers?.map((identifier) => (
                              <option key={identifier.id} value={identifier.id}>
                                {identifier.name}
                              </option>
                            ))}
                          </select>

                        </Col>

                        <Col md={6}>
                          <strong>Signature:</strong> <img src={formState.mobilizer?.signature} height={50} />
                        </Col>
                      </Row>

                    </CardBody>
                  </Card>
                </Row>

              </FormWizard.TabContent>
            </FormWizard>
            <style>{`
        @import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
      `}</style>
          </div>
        </Col>
      </Row>

      <Modal show={showModal} onHide={handleModalClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Brick Kiln</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StoreBrickkiln from={true} handleStoreModal={handleStoreModal} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>

        </Modal.Footer>
      </Modal>
    </PageLayout >
  );
}
